import React from "react";
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Avatar,
} from "@mui/material";
import { useSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import YesNo from "../../../../../components/EditProfileDialog/components/YesNo";
import Choice from "../../../../../components/EditProfileDialog/components/Choice";
import Range from "../../../../../components/EditProfileDialog/components/Range";
import PreferredAgeRange from "../../../../../components/EditProfileDialog/components/PreferredAgeRange";
import { toast } from "../../../../../utilities/SnackBarUtils";
import request from "../../../../../utilities/requests";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EventProfileDialog = ({ selectedProfile, close, user }) => {
  const [open, setOpen] = React.useState(false);
  const [questions, setQuestions] = React.useState([]);

  React.useEffect(() => {
    if (selectedProfile) {
        setOpen(true);
        getQuestions()
    } else {
        setOpen(false);
        setQuestions([]);
    }

  },[selectedProfile])

  const handleSave = () => {};

  const getQuestions = async (eventId, userId) => {
    const url = `profilequestions/bygroup?questionGroupId=${selectedProfile}&userId=${user._id}`;
    const result = await request(url);
    if (result.success) {
      setQuestions(result?.profileQuestions);
    }
  };

  const handleChange = async (id, answer) => {
    const body = { userId: user._id, questionId: id, answer };
    const result = await request("profilequestions/answer", "post", body);
    if (result.success) {
      const qs = questions.map((question) => {
        if (question._id === id) {
          return { ...question, answer };
        }
        return question;
      });
      setQuestions(qs);
      toast.success("Profile updated successfully");
    }
  };

  const renderQuestions = () => {
    return questions.map((question) => {
      if (question.variant === "preferredAge") {
        return (
          <PreferredAgeRange
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      } else if (question.questionType === "yesno") {
        return (
          <YesNo
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      } else if (question.questionType === "choice" || question.questionType === "multipleChoice") {
        return (
          <Choice
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      } else if (
        question.questionType === "related" &&
        question.choices.length > 0
      ) {
        return (
          <Choice
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      } else if (
        question.questionType === "related" &&
        question.choices.length === 0
      ) {
        return (
          <YesNo
            key={question._id}
            question={question}
            onChange={handleChange}
          />
        );
      } else if (question.questionType === 'range') {
        return <Range key={question._id} question={question} onChange={handleChange}/>
      }
    });
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={close}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Edit Event Profile
          </Typography>
        </Toolbar>
      </AppBar>
      <Grid container spacing={3} style={{ padding: 20 }}>
        {renderQuestions()}

        <Grid item xs={12}>
          <Button
            variant="outlined"
            onClick={() => close()}
            style={{ width: "100%" }}
          >
            Close
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default EventProfileDialog;
